import { Box, Skeleton, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';

export default function IntegrationsLoader() {
  const theme = useTheme();

  return (
    <Box p={3}>
      {/* Integration Cards */}
      <Grid container spacing={3}>
        {[1, 2].map((idx) => (
          <Grid key={`integration-skeleton-${idx}`} size={{ xs: 12, sm: 6, md: 4 }}>
            <Box
              bgcolor={theme.palette.background.paper}
              border='1px solid #ECECEC'
              borderRadius='10px'
              p={3}
              minHeight={180}
              display='flex'
              flexDirection='column'
              justifyContent='space-between'
            >
              {/* Card Header */}
              <Box display='flex' alignItems='center' gap={2} mb={2}>
                <Skeleton variant='circular' width={40} height={40} />
                <Box>
                  <Skeleton variant='text' width={120} height={24} />
                  <Skeleton variant='text' width={80} height={18} />
                </Box>
              </Box>

              {/* Card Description */}
              <Skeleton variant='text' width='100%' height={18} sx={{ mb: 1 }} />
              <Skeleton variant='text' width='80%' height={18} />

              {/* Buttons */}
              <Box display='flex' gap={2} mt={2}>
                <Skeleton variant='rectangular' width={100} height={36} sx={{ borderRadius: 1 }} />
                <Skeleton variant='rectangular' width={100} height={36} sx={{ borderRadius: 1 }} />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
